import { render, staticRenderFns } from "./ParentsIndex.vue?vue&type=template&id=44e3c1fc&"
import script from "./ParentsIndex.vue?vue&type=script&lang=js&"
export * from "./ParentsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports